export const ReferralRewardCode = {
  FREE_BLOOM_PRO: 'FREE_BLOOM_PRO',
  AMAZON_TICKET: 'AMAZON_TICKET',
} as const

export type ReferralRewardCodeType = (typeof ReferralRewardCode)[keyof typeof ReferralRewardCode]
